export let sendAnalytics: AnalyticsMethod,
  googleMapKey: string = '',
  store: any,
  selectors: any,
  isEmployee: boolean = false,
  isFirstVisit: boolean = false,
  isPaying: boolean = false;

export const setAnalyticsMethod = (method: AnalyticsMethod) => {
  sendAnalytics = method;
};

export const setGoogleMapKey = (key: string) => {
  googleMapKey = key;
};

export const setStore = (s: any) => {
  store = s;
};

export const setSelectors = (s: any) => {
  selectors = s;
};

export const setIsEmployee = (value: boolean) => {
  isEmployee = value;
};

export const setIsPaying = (value: boolean) => {
  isPaying = value;
};

export const setFirstVisit = (value: boolean) => {
  isFirstVisit = value;
};
